import { HttpParams } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { LoteService } from 'src/app/core/services/lote.service';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { Certificado } from 'src/app/models/Certificado.model';
import { SearchFunction } from 'src/app/shared/components/search-autocomplete/search-autocomplete.component';
import { Lote } from 'src/app/models/Lote.model';
import { HelpToursService } from 'src/app/core/tours/help-tours.service';
import { k } from 'src/environments/properties';

@Component({
  selector: 'app-search-certificate-component',
  templateUrl: './search-certificate.html',
  styleUrls: ['./search-certificate.css']
})
export class SearchCertificateComponent implements OnInit, OnDestroy {
  email: string = ''; // Propiedad para almacenar el valor del input
  @Output() agregarCertificado = new EventEmitter<{ data: string; firmaImg: boolean }>();
  @Output() misCertficados = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  public certificados: Certificado[] = [];
  private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente
  idLote: any = null; // Para almacenar el ID del lote
  search: SearchFunction;
  firmaConImagen: boolean = false;

  constructor(
    private certificadoService: CertificadoService,
    private route: ActivatedRoute,
    private usuarioService: UsuariosService,
    private loteService: LoteService,
    private firmaStateService: FirmaStateService,
    private tours: HelpToursService
  ) {
  }
  ngOnDestroy(): void {
    this.tours.stop();
  }


  ngOnInit(): void {

    this.search = this.getUser2.bind(this);

    this.route.paramMap
      .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
      .subscribe(async params => {
        // 'id' es el nombre del parámetro definido en tu configuración de rutas
        // Por ejemplo: path: 'firmas/firma/:id'
        const id = params.get('id');

        if (id != "firma") {
          this.idLote = id; // El '+' convierte el string a número
          // procedemos a precargar la data de los pasos
          await this.precargarData(this.idLote);

        } else {
          this.idLote = null;
        }
      });
  }


  async precargarData(id: number): Promise<any> {
    let lote = (this.firmaStateService.getCurrentState())?.lote;

    if (!lote) { // sino hemos precargado anteriormente nuestro estado global procedemos a cargar y redireccionar el stepper

      lote = (await this.showLote(id)) as Lote;
    }
  }

  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }


  async searchMyCertificates(){  
    await this.realizarBusqueda({
      correo: localStorage.getItem(k.correo)
    });
  }


  async realizarBusqueda($event: any) {
    let params = new HttpParams(); // Inicia un nuevo objeto HttpParams
    params = params.set('correo', $event.correo);
    const response = await lastValueFrom(this.certificadoService.get<Certificado[]>({ params }));
    this.certificados = response.body ?? [];
    this.onHelpSeleccionCertificado()
  }

  onHelpSeleccionCertificado(force = false) {
    this.tours.start('modal_agregar_certificado_seleccion_help', force)
  }

  async agregarCertificadoLote(certificado: any) {
    this.agregarCertificado.emit({ data: certificado, firmaImg: this.firmaConImagen });
  }

  disabledButton(state: boolean) {
    this.disabled = state;
  }

  async getUser2(search: string = '') {
    const result = await lastValueFrom(this.usuarioService.getUsuarios(1, 1, search, 'false'));

    return result.body.map((x: any, index: number) => {

      return {
        id_user: x.id,
        nombre: (x.firstName + ' ' + x.lastName),
        usuario: (x.username), correo: x.email, estado: (x.isActive == true ? 'Activo' : 'Inactivo')
      }
    });
  }
}